(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mbc-core"));
	else if(typeof define === 'function' && define.amd)
		define(["mbc-core"], factory);
	else if(typeof exports === 'object')
		exports["mbc-flag"] = factory(require("mbc-core"));
	else
		root["mbc-flag"] = factory(root["mbc-core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 118);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(19);


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(99);

var _flag = __webpack_require__(59);

var _flag2 = _interopRequireDefault(_flag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _flag2.default;

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ToolTipConfig = function ToolTipConfig() {

    this._DEFAULT_CONFIG = {
        template: function template(d) {
            return "<div class='tooltip-inner'>" + d.value + "</div>";
        }
    };

    this._config = this._DEFAULT_CONFIG;
};

ToolTipConfig.prototype.configuration = function (v) {
    if (arguments.length === 0) {
        return this._config;
    }

    // Polyfill for ES6 assign method
    if (typeof Object.assign !== "function") {
        Object.assign = function (target) {
            /*jshint maxcomplexity:6 */
            if (target === null) {
                throw new TypeError("Cannot convert undefined or null to object");
            }

            target = Object(target);
            for (var index = 1; index < arguments.length; index++) {
                var source = arguments[index];
                if (source !== null) {
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key];
                        }
                    }
                }
            }

            return target;
        };
    }

    this._config = Object.assign({}, this._DEFAULT_CONFIG, v);
    return this;
};

ToolTipConfig.prototype.template = function (v) {
    if (arguments.length === 0) {
        return this._config.template;
    }

    this._config.template = v;

    return this;
};

var configuration = exports.configuration = new ToolTipConfig();

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getPositionTop(ttClientRect, canvas, mousePosition, position) {
    var tooFarLeft, tooFarRight, tooLow, tooHigh;
    tooFarRight = mousePosition[0] >= canvas.width() - ttClientRect.width / 2;
    tooFarLeft = mousePosition[0] < ttClientRect.width / 2;
    tooHigh = mousePosition[1] < ttClientRect.height;
    tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
    if (tooHigh && !tooFarLeft && tooFarRight) {
        position = "bottom-left";
    } else if (tooHigh && tooFarLeft && !tooFarRight) {
        position = "bottom-right";
    } else if (tooHigh) {
        position = "bottom";
    } else if (!tooFarLeft && tooFarRight) {
        position = "top-left";
    } else if (tooFarLeft && !tooFarRight) {
        position = "top-right";
    }

    return position;
}

function getPositionBottom(ttClientRect, canvas, mousePosition, position) {
    var tooFarLeft, tooFarRight, tooLow, tooHigh;
    tooFarRight = mousePosition[0] >= canvas.width() - ttClientRect.width / 2;
    tooFarLeft = mousePosition[0] < ttClientRect.width / 2;
    tooHigh = mousePosition[1] < ttClientRect.height;
    tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
    if (tooLow && !tooFarLeft && tooFarRight) {
        position = "top-left";
    } else if (tooLow && tooFarLeft && !tooFarRight) {
        position = "top-right";
    } else if (tooLow) {
        position = "top";
    } else if (!tooFarLeft && tooFarRight) {
        position = "bottom-left";
    } else if (tooFarLeft && !tooFarRight) {
        position = "bottom-right";
    }

    return position;
}

function getPositionTopRight(ttClientRect, canvas, mousePosition, position, isLine) {
    var tooFarLeft, tooFarRight, tooLow, tooHigh;
    var width = isLine ? ttClientRect.width * 2 : ttClientRect.width;
    tooFarRight = mousePosition[0] >= canvas.width() - width;
    tooFarLeft = mousePosition[0] < width;
    tooHigh = mousePosition[1] < ttClientRect.height;
    tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
    if (tooHigh && tooLow) {
        tooHigh = false;
    }
    if (tooHigh && !tooLow && !tooFarRight) {
        position = "bottom-right";
    } else if (tooHigh && !tooLow && tooFarRight) {
        position = "bottom-left";
    } else if (!tooHigh && tooFarRight) {
        position = "top-left";
    }

    return position;
}

function getRightTop(ttClientRect, canvas, mousePosition, position, isLine) {
    var tooFarRight, tooLow;
    var width = isLine ? ttClientRect.width * 2 : ttClientRect.width;
    tooFarRight = mousePosition[0] >= canvas.width() - width;
    tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
    if (tooFarRight && tooLow) {
        position = "left-bottom";
    } else if (tooFarRight) {
        position = "left-top";
    } else if (tooLow) {
        position = "right-bottom";
    }

    return position;
}

/**
 * @method changeToolTipDirection
 * @desc Uses the coordinate information to decide how the tooltip should be positioned in the canvas. Determines top and bottom boundry when size of flag exceeds size of canvas.
 *
 * @return undefined
 **/
function changeToolTipDirection(ttClientRect, canvas, mousePosition, position) {
    var chartCanvas = canvas.get("svg").select(".mbc-front-group").node().getBoundingClientRect();

    var canvasWidth = chartCanvas.width; // Chart plotted width
    var canvasHeight = chartCanvas.height; // Chart plotted height

    var tooFarRight = ttClientRect && mousePosition[0] >= canvasWidth - ttClientRect.width; //Boolean for right canvas boundry
    var tooFarLeft = ttClientRect && mousePosition[0] < canvasWidth - ttClientRect.width; //Boolean for left canvas boundry
    var tooHigh = ttClientRect && mousePosition[1] <= ttClientRect.height; //Boolean for top canvas boundry
    var tooLow = ttClientRect && mousePosition[1] >= canvasHeight - ttClientRect.height; //Boolean for bottom canvas boundry

    var windowHeight = window.innerHeight; // Window/viewport height to use for bottom boundry
    var viewportMousePositionY = d3.event.clientY; // Y mouse position relative to window/viewport
    var exceedsViewportTop = ttClientRect && ttClientRect.height - mousePosition[1] > chartCanvas.top; //Boolean check if tooltip exceeds beyond viewport top
    var exceedsViewportBottom = ttClientRect && viewportMousePositionY + ttClientRect.height > windowHeight; //Boolean check if tooltip exceeds beyond viewport bottom

    // If flag exceeds top and bottom of canvas, then check collision with viewport viewport
    if (tooHigh && tooLow) {

        // Check collision to viewport, default to display flag down if conditions both fail
        tooHigh = !exceedsViewportTop && exceedsViewportBottom ? false : true;
        tooLow = !exceedsViewportTop && exceedsViewportBottom ? true : false;
    }

    // If flag exceeds neither the top or bottom of canvas default the position
    if (!tooHigh && !tooLow) {
        tooLow = true;
    }

    if (tooFarRight && tooLow) {
        position = "left-bottom";
    }

    if (tooFarLeft && tooLow) {
        position = "right-bottom";
    }

    if (tooFarRight && tooHigh) {
        position = "left-top";
    }

    if (tooFarLeft && tooHigh) {
        position = "right-top";
    }

    return position;
};

module.exports = {
    top: getPositionTop,
    bottom: getPositionBottom,
    topRight: getPositionTopRight,
    rightTop: getRightTop,
    setPosition: changeToolTipDirection
};

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _mbcCore = __webpack_require__(0);

var _mbcCore2 = _interopRequireDefault(_mbcCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configuration = __webpack_require__(57).configuration;
var positioning = __webpack_require__(58);

var Classes = _mbcCore2.default.Classes;
var Utils = _mbcCore2.default.Utils;

/**
 * D3 tooltip plugin
 * Modification of https://github.com/roncr/d3-tooltip-box
 * @class Tooltip
 */
var ToolTip = function ToolTip(options) {

    options = options || {};
    this.__OPTIONS = options;
    this._tooltipMap = {
        top: { top: true },
        "top-left": { top: true, "top-left": true },
        "top-right": { top: true, "top-right": true },
        bottom: { bottom: true },
        "bottom-left": { bottom: true, "bottom-left": true },
        "bottom-right": { bottom: true, "bottom-right": true },
        left: { left: true },
        "left-top": { left: true, "left-top": true },
        "left-bottom": { left: true, "left-bottom": true },
        right: { right: true },
        "right-top": { right: true, "right-top": true },
        "right-bottom": { right: true, "right-bottom": true }
    };

    var defaultOptions = {
        position: "top-right",
        delay: 250,
        transitionDuration: 20,
        opacity: 0.95,
        transition: true
    };

    Utils.object.copy(defaultOptions, options);

    this._options = defaultOptions;

    // Constants
    this._DEFAULT_POSITION_OFFSET = { top: 0, left: 0 };

    // Variables
    this._tooltipClass = Classes.TOOLTIP_CONTAINER;
    this._parent = d3.select("body");
    this._dataAccessor = function (d) {
        return d;
    };

    this._template = configuration.template();
    this._positionOffset = this._DEFAULT_POSITION_OFFSET;
};

/**
 * Initializes the tooltip container, if there is already
 * a container, reuses the same tooltip, otherwise creates
 * a new <div> container
 * @returns {d3.selection} tooltip container
 * @private
 */
ToolTip.prototype._initTooltip = function () {
    var tooltipEl = d3.select("." + this._tooltipClass);
    if (tooltipEl.empty()) {
        tooltipEl = this._createTooltip(this._options);
    }

    return tooltipEl;
};

/**
 * Creates a new <div> as the container of the tooltip
 * @returns {d3.selection} new tooltip container
 * @private
 */
ToolTip.prototype._createTooltip = function (options) {
    var positionClass = this._tooltipMap[options.position];
    var tooltip = this.parent().append("div").attr("class", this._tooltipClass).classed("tooltip", true).classed(positionClass).style('display', 'none').classed("in", true).classed("fade", true);

    if (this._options && this._options.namespace && typeof this._options.namespace === "string") {
        tooltip.classed(this._options.namespace + "-tooltip", true);
    }

    return tooltip;
};

/**
 * Gets the content of the tooltip by either
 * compiling a static template or invoking the
 * function of a dynamic template
 * @param d the associated data
 * @returns {ELEMENT_NODE} content of the tooltip as HTML
 * @private
 */
ToolTip.prototype._getContent = function (d) {
    var template = this._template;

    var compileTemplate = function compileTemplate(template, data) {
        for (var prop in data) {
            var regex = new RegExp("\\@\\{" + prop + "}", "gi");
            template = template.replace(regex, data[prop]);
        }

        return template;
    };

    if (typeof template === "function") {
        return template(d);
    } else {
        var data = this._dataAccessor(d);
        return compileTemplate(template, data);
    }
};

/**
 * Parent getter/setter
 * @param v the parent to set
 * @returns {d3.selection} the current parent (returned only if
 * invoked with no parameters)
 */
ToolTip.prototype.parent = function (v) {

    var isD3Selection = function isD3Selection(obj) {
        return obj instanceof d3.selection;
    };

    if (arguments.length === 0) {
        return this._parent;
    }

    if (!isD3Selection(v)) {
        v = d3.select(v);
    }

    this._parent = v;
    return this;
};

/**
 * Position offset getter/setter, the offset must
 * be in the shape of {left: 0, top: 0}
 * @param v the offset to set
 * @returns {Object} current offset (returned only if invoked with
 * not parameters)
 */
ToolTip.prototype.positionOffset = function (v) {
    if (arguments.length === 0) {
        return this._positionOffset;
    }

    this._positionOffset = {};
    Utils.object.copy(this._positionOffset, this._DEFAULT_POSITION_OFFSET, v);
    return this;
};

/**
 * Data accessor getter/setter
 * @param v the accessor function to set
 * @returns {Function} the current accessor function (returned only if
 * invoked with no parameters)
 */
ToolTip.prototype.data = function (v) {
    if (arguments.length === 0) {
        return this._dataAccessor;
    }

    this._dataAccessor = v;
    return this;
};

/**
 * Template getter/setter
 * @param v the template to set, if string it is considered
 * static template, if function it is considered dynamic template
 * and will be invoked with the associated data as parameter
 * @returns {*} the current template string or factory function
 * (returned only if invoked with no parameters)
 */
ToolTip.prototype.template = function (v) {
    if (arguments.length === 0) {
        return this._template;
    }

    this._template = v;
    return this;
};

/**
 * Makes the tooltip visible
 * @param d the associated data of the selection
 */
ToolTip.prototype.show = function (d, changes) {
    var html, options;

    if (changes) {
        var defaultOptions = { position: "top-right" };
        Utils.object.copy(defaultOptions, changes);
        if (changes.isStyleMap && changes.tooltipType === "tooltipObjectCentroid") {
            this._options.position = changes.position;
            this._options.transition = null;
        } else {
            this._options = defaultOptions;
        }
    }

    if (!this._tooltipEl) {
        this._tooltipEl = this._initTooltip();
    }

    options = this._options;

    if (!this._disabled) {
        html = this._getContent(d);

        if (html !== null && typeof html !== "undefined") {
            html += "<div class='tooltip-arrow'></div>";
            this._tooltipEl.html(html);
            if (options.transition) {
                this._tooltipEl.style({
                    opacity: 0,
                    display: "inline-block"
                }).transition().duration(options.transitionDuration).delay(options.delay).style({
                    opacity: options.opacity
                });
            } else {
                this._tooltipEl.style({
                    opacity: options.opacity,
                    display: "inline-block"
                });
            }
        }
    }
};

ToolTip.prototype.disabled = function (disabled) {
    this._disabled = disabled;
};

// This method calculates the flag positioning inside the chart canvas based on its initial position.
function calcPosition(tooltip, canvas, position, mousePosition, isLine) {
    var ttClientRect = tooltip.node().getBoundingClientRect();
    return positioning.setPosition(ttClientRect, canvas, mousePosition, position);;
}

/**
 * Moves the tooltip to the mouse position
 */
ToolTip.prototype.move = function (d, mousePosition) {

    // If the tooltip is not shown already, show it
    if (!this._tooltipEl) this.show(d);

    var autoposition = this._options.autoposition;
    var _this = this;
    var positionClass;
    var isLine = _this.__OPTIONS.chart === "line";
    var isTimeSeries = _this.__OPTIONS.chart === "time-series";

    var getOffset = function getOffset(ctx) {
        var tooltipEl = ctx._tooltipEl;
        var clientRect = tooltipEl.node().getBoundingClientRect();
        var height = clientRect.height;
        var width = clientRect.width;
        var position = ctx._options.position;
        var top = 0;
        var left = 0;

        // Note this if block is unreachable because autoposition is never set anywhere
        if (autoposition) {
            position = calcPosition(tooltipEl, autoposition, position, mousePosition, isLine);
        }

        positionClass = ctx._tooltipMap[position];

        tooltipEl.classed({
            top: false,
            "top-left": false,
            "top-right": false,
            bottom: false,
            "bottom-left": false,
            "bottom-right": false,
            left: false,
            "left-top": false,
            "left-bottom": false,
            right: false,
            "right-top": false,
            "right-bottom": false
        }).classed(positionClass);

        switch (position) {
            case "top":
                top = height;
                left = width / 2;
                break;

            case "top-left":
                top = height;
                left = width;
                break;

            case "top-right":
                top = height;
                break;

            case "bottom":
                left = width / 2;
                top = -10;
                break;

            case "bottom-left":
                left = width;
                top = -10;
                break;

            case "bottom-right":
                top = -10;
                break;

            case "left":
                top = height / 2;
                left = width;
                break;

            case "left-top":
                left = width;
                break;

            case "left-bottom":
                left = width;
                top = height;
                break;

            case "right":
                top = height / 2;
                left = -5;
                break;

            case "right-top":
                left = -5;
                break;

            case "right-bottom":
                left = -5;
                top = height;
                break;

            default:
                break;
        }

        return { top: top, left: left };
    };

    var clientRect = _this._tooltipEl.node().getBoundingClientRect();

    _this._clientRect = clientRect;
    _this._positionOffset = getOffset(_this);

    if (isLine) {
        var select = document.querySelector(".mbc-line-chart-tooltip");
        var mouse = d3.mouse(select);
        var closestLine = _this.getCalculation();
        var zoneWidth = _this.__OPTIONS.flagZoneWidth;
    }

    var formatPx = function formatPx(value) {
        return value + "px";
    };
    var padding = -5;

    if (_this.hasPositionLeft(positionClass)) {
        padding = clientRect.width + 5;
    }

    if (isTimeSeries) {
        var closestLine = _this._options.hoverLeft - _this._positionOffset.left;
        padding = 3;
    }

    _this._tooltipEl.style({
        position: "absolute",
        left: isLine || isTimeSeries ? formatPx(closestLine - padding) : formatPx(d3.event.pageX - _this._positionOffset.left),
        top: formatPx(d3.event.pageY - _this._positionOffset.top)
    });
};

ToolTip.prototype.hasPositionLeft = function (pos) {
    return pos.hasOwnProperty("top-left") || pos.hasOwnProperty("bottom-left") || pos.hasOwnProperty("left-top") || pos.hasOwnProperty("left-bottom");
};

ToolTip.prototype.getCalculation = function () {
    var isTimeSeries = this.__OPTIONS.chart === "time-series";
    var select = document.querySelector("body");
    var lines = Array.prototype.slice.call(document.querySelectorAll(".mouse-line")).map(function (line) {
        return line.getBoundingClientRect().left;
    });

    var position;
    var mouse = d3.mouse(select)[0];

    var zoneWidth = this.__OPTIONS.flagZoneWidth;
    var canvasWidth = this.__OPTIONS.canvasWidth;
    var zones = Math.round(canvasWidth / zoneWidth);
    var findRange = function findRange() {
        var w = Math.floor(zoneWidth / 2);
        lines.forEach(function (line, idx) {
            if (mouse >= line - w && mouse <= line + w) {
                position = line;
                return false;
            }
        });
    };

    findRange();

    return position;
};

/**
 * Hides the tooltip
 */
ToolTip.prototype.hide = function () {
    if (this._tooltipEl) {
        this._tooltipEl.transition();
    }

    var container = d3.select(".mbc-chart-tooltip-container");
    container.remove();
    this._tooltipEl = null;
};

/**
 * Attaches the tooltip event listeners to
 * the current selection
 * @returns {Function} function to be used for the
 * d3.selection.call method
 */
ToolTip.prototype.bind = function () {
    var _this = this;

    return function (selection) {
        selection.each(function () {
            var element = d3.select(this);

            element.on("mousemove.tooltip-container", function (d) {
                return _this.move(d, d3.mouse(this));
            }).on("mousewheel.tooltip-container", function () {
                return _this.hide();
            }).on("mouseout.tooltip-container", function () {
                return _this.hide();
            });
        });
    };
};

/**
 * Tooltip factory, creates new instances of the tooltip
 * @returns {Tooltip} the new tooltip instance
 */
function create(options) {
    var instance = new ToolTip(options);
    return instance;
}

module.exports = create;

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });
});